import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { AcademyInUseRequest } from "../shared/AcademyInUseRequest";
import { DataService_AcademySetup } from "../shared/data.service";
import { EditAcademyRequest } from "../shared/EditAcademyRequest";

@Component({
	selector: "caass-school-edit-academy",
	templateUrl: "./school-edit-academy.component.html",
	styleUrls: ["./school-edit-academy.component.css"],
})
export class SchoolEditAcademyComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private AcademySetupService: DataService_AcademySetup
	) {}

	ngOnInit(): void {
		//Get data from parent
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.SelectedAcademy = this.dialogConfig.data.SelectedAcademy;

		//Update data
		this.AcademyCD = this.SelectedAcademy.AcademyCD;
		this.AcademyDesc = this.SelectedAcademy.AcademyDesc;

		this.OriginalCD = this.SelectedAcademy.AcademyCD;
		this.OriginalDesc = this.SelectedAcademy.AcademyDesc;

		//INSERT LOAD COMBO BOX DATA
		this.loadAdminPerson();
	}

	///////////////////////////////////////
	// Data
	///////////////////////////////////////

	errorMessage: any = "";

	//Data from parent
	SchoolID: any;
	SelectedAcademy: any;

	//INSERT FORM DATA
	AcademyDesc: any = "";
	AcademyCD: any = "";
	DirectorID: any = 0;

	LoadingStaff: boolean = false;
	SelectedStaff: any;
	lstStaff: any = [];

	OriginalDesc: any = "";
	OriginalCD: any = "";

	Processing: boolean = false;

	///////////////////////////////////////

	///////////////////////////////////////
	// Load Data
	///////////////////////////////////////

	//INSERT LOAD DATA METHODS
	loadAdminPerson() {
		this.LoadingStaff = true;

		var result = this.AcademySetupService.LoadStaff(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstStaff = response;

				this.SelectedStaff = null;

				this.lstStaff.unshift({
					PersonID: -1,
					StaffFullName: "N/A",
				});

				this.SelectedStaff = this.lstStaff[0];

				if (this.SelectedAcademy.Director_PersonID > 0) {
					for (var z = 0; z < this.lstStaff.length; z++) {
						var next = this.lstStaff[z];

						if (next.PersonID == this.SelectedAcademy.Director_PersonID) {
							this.SelectedStaff = next;
							break;
						}
					}
				}

				this.LoadingStaff = false;
			},
			(error) => {
				this.LoadingStaff = false;
			}
		);
	}

	///////////////////////////////////////

	///////////////////////////////////////
	// Buttons
	///////////////////////////////////////

	//INSERT CUSTOM BUTTON METHODS
	onEditAcademy() {
		if (this.AcademyDesc == "") {
			this.errorMessage = "Enter a name";
			return;
		}
		if (this.AcademyCD == "") {
			this.errorMessage = "Enter a code";
			return;
		}

		this.Processing = true;

		if (String(this.AcademyDesc) != String(this.OriginalDesc)) {
			this.CheckName();
		} else if (String(this.AcademyCD) != String(this.OriginalCD)) {
			this.CheckCD();
		} else {
			this.onFinishUpdate();
		}
	}

	CheckName() {
		let parms: AcademyInUseRequest = {
			str: this.AcademyDesc,
			SchoolID: this.SchoolID,
		};

		var result = this.AcademySetupService.AcademyNameInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.Processing = false;
					this.errorMessage = "Academy Name Already in Use";
					return;
				} else {
					if (String(this.AcademyCD) != String(this.OriginalCD)) {
						this.CheckCD();
					} else {
						this.onFinishUpdate();
					}
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	CheckCD() {
		let parms: AcademyInUseRequest = {
			str: this.AcademyCD,
			SchoolID: this.SchoolID,
		};

		var result = this.AcademySetupService.AcademyCDInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.Processing = false;
					this.errorMessage = "Academy Abbreviation Already in Use";
					return;
				} else {
					this.onFinishUpdate();
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onFinishUpdate() {
		let parms: EditAcademyRequest = {
			AcademyID: this.SelectedAcademy.AcademyID,
			AcademyCD: this.AcademyCD,
			AcademyDesc: this.AcademyDesc,
			Director_PersonID: this.SelectedStaff.PersonID,
		};

		var result = this.AcademySetupService.EditAcademy(parms);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Academy was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Academy",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////

	///////////////////////////////////////
	// Helpers
	///////////////////////////////////////

	IsLoading() {
		return this.LoadingStaff == true || this.Processing == true;
	}

	///////////////////////////////////////
}
